import { toRem } from 'helpers/theme'
/* eslint-disable quote-props */

const style = ({ theme, columns }) => ({
    margin: '40px 0 35px 0',
    background: theme.colors.blueLight,
    overflow: 'hidden',

    [theme.breakpoints.up('520')]: {
        margin: '70px 0 60px 0',
        padding: '60px 0'
    },

    '& .contactsTitle': {
        maxWidth: 1360,
        margin: '0 auto',
        padding: '30px 20px',
        color: theme.colors.goldDark,
        fontWeight: 400,
        fontSize: toRem(24),
        [theme.breakpoints.up('520')]: {
            fontSize: toRem(35),
            padding: '40px 20px'
        }
    },
    '& .contactsList': {
        maxWidth: 1360,
        display: 'grid',
        gridTemplateColumns: '1fr',
        listStyleType: 'none',
        margin: '0 auto',
        padding: '0 20px',
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '1fr 1fr'
        },
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: '1fr 1fr 1fr'
        },
        '&-item': {
            position: 'relative',
            flexBasis: '100%',
            marginBottom: toRem(40),
            [theme.breakpoints.up('520')]: {
                ...(columns === 4 && {
                    marginBottom: toRem(60)
                })
            },
            img: {
                maxWidth: 240,
                minWidth: 'auto',
                width: '100%'
            }
        }
    }
})

export default style
